import { Card, Form } from "@deere/ux.uxframe-react";
import React from "react";
import { getAnswerLabel, getTranslation, findAnswerIndex } from "../../utils/utils";
import { QUESTION_PROPRIETARY } from "../../utils/surveyLiterals";

export default function CyberSecurityReviewSection({ sectionSurvey, answers }) {
  if (!sectionSurvey) return <></>;

  const questions = sectionSurvey.questions.filter((qu) => qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1));
  
  function createRow(q) {
    let answer = getAnswerLabel(q, answers);
    if (q.idQuestionDepends && q.idQuestionDepends > 0) {
      return answer === "-" ? null : (
        <Form.Group className="mb-4 pl-4">
          <Form.Label className="uxf-label">{getTranslation(q, "text")}</Form.Label>
          <h6>{answer}</h6>
        </Form.Group>
      );
    } else {
      return (
        <Form.Group>
          <Form.Label className="uxf-label">{getTranslation(q, "text")}</Form.Label>
          <h6>{answer}</h6>
        </Form.Group>
      );
    }
  }

  return (
    <div>
      <Card>
        <Card.Body>
          <Card.Title className="pb-3">{getTranslation(sectionSurvey, "description")}</Card.Title>
          {questions ? (
            questions.map((q, idx) => (
              <div key={idx}>
                <Form.Row className="d-block mb-4" key={idx}>
                  {q.type === "RADIO" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRow(q, idx) : <></>}
                  {q.type === "OPEN" && (q.dependentQuestions === "undefined" || q.dependentQuestions.length <= 0) ? createRow(q, idx) : <></>}
                </Form.Row>
              </div>
            ))
          ) : (
            <></>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}
